export default __webpack_public_path__ + "static/media/bacqueville2.3c8a5167.jpg";